import "../../utils/proxiedGenerated";
import SearchBar from "./SearchBar";
export default SearchBar;
